import { u as f } from "../vee-validate.esm-c4518011.js";
import { ref as v, computed as d } from "vue";
import { useScrollTo as p } from "./useScrollTo.js";
const w = (a, l, r) => {
  const n = v(!1), { scrollIntoView: s } = p(), u = f();
  return async function(e) {
    e instanceof Event && (e.preventDefault(), e.stopPropagation());
    const c = d(() => l);
    n.value = !0;
    try {
      const t = await u();
      let i;
      if (t.valid && typeof r == "function")
        i = r(c.value, {
          evt: e
        });
      else if (!t.valid) {
        const m = Object.keys(t.errors), o = a.value.querySelector(
          `[name=${m[0]}]`
        );
        s(o, void 0, t.errors), o == null || o.focus();
      }
      return i;
    } catch (t) {
      return console.error(
        "[useSubmitForm]: Failed doing validation. Exit with:",
        t
      ), null;
    } finally {
      n.value = !1;
    }
  };
};
export {
  w as submitForm
};
